import request from '@/utils/request'

export function addEvent(data) {
  return request({
    url: '/userEvent/addEvent',
    method: 'post',
    data
  })
}
